import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Select } from '../../Select';
export const MonthSelect = React.memo(function MonthSelect({ date, changeMonth, locale }) {
    const formatter = new Intl.DateTimeFormat(locale, { month: 'long' });
    const months = Array.from({ length: 12 }, (_, index) => ({
        value: index,
        label: formatter.format(new Date(2000, index, 1)),
    }));
    return (_jsx(Select, { value: months[date.getMonth()], onChange: (option) => option && changeMonth(months.indexOf(option)), options: months }));
});
